import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {ScoresDesktopLiveEmptyState} from "./scores.desktop.live-empty-state";
import {ScoresMobileLiveEmptyState} from "./scores.mobile.live-empty-state";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {UseHookOnRenderComplete} from "../../composers/composer-plugins/use-hook-on-render-complete";

export class ScoresLiveEmptyStateComponentProps extends BaseProps {
  linkModel: BaseLinkModel;
  text: String;
  buttonText: String;
  isLargeView: Boolean;
  ImageSrc: String;
  onClick: Function;
}

export const ScoresLiveEmptyState = UseHookOnRenderComplete()((props: ScoresLiveEmptyStateComponentProps) => {
  const emptyStateProps = {
    text: props.text,
    buttonText: props.buttonText,
    linkModel: props.linkModel,
    ImageSrc: props.ImageSrc,
    onClick: props.onClick
  }

  return (
    <React.Fragment>
      {
        props.isLargeView ?
          <ScoresDesktopLiveEmptyState {...emptyStateProps}/> :
          <ScoresMobileLiveEmptyState {...emptyStateProps}/>
      }
    </React.Fragment>
  )
});